<template>
  <div class="flex flex-col">
    <div
      class="header-container flex items-center justify-between bg-background">
      <slot>
        <div class="flex items-center gap-2 text-xl">
          <p
            v-if="props.backRoute"
            class="cursor-pointer"
            @click="router.push({ name: props.backRoute })">
            {{ backRouteTitle }}
          </p>
          <p v-if="props.backRoute">/</p>
          <div class="font-bold">
            <slot name="title">
              <p v-if="titleKey">
                {{ i18n.t(titleKey) }}
              </p>
              <p v-else-if="name">{{ props.name }}</p>
              <p v-else></p>
            </slot>
          </div>
        </div>
      </slot>

      <BaseHeaderMenu />
    </div>

    <slot name="tabs" />
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import { useRouter } from 'vue-router'

  const i18n = useI18n()
  const props = defineProps<{
    name?: string
    titleKey?: string
    backRoute?: string
  }>()
  const router = useRouter()

  const backRouteTitle = computed(() => {
    if (props.backRoute) {
      const route = router.resolve({ name: props.backRoute })
      return i18n.t(route?.meta.titleKey as string) || route.name || ''
    }
    return ''
  })
</script>

<style scoped lang="scss">
  .header-container {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: var(--home-padding);
    min-height: var(--layout-size-header);
  }

  .title {
    margin-right: auto;
  }

  .back-arrow {
    cursor: pointer;
  }
</style>
